import React from 'react'
import { Link } from 'react-router-dom'

const RefereeDetail = () => {
    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Referee Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Referee Details</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="detail_top_pgg">
                        <Link to="/referee-management"><i className="bx bx-arrow-back" /><span>Back</span></Link>
                    </div>
                    <div className="card personal_d">
                        <div className="card-body">
                            <h2>Personal Details</h2>
                            <div className="row">
                                <div className="col-lg-2">
                                    <div className="d-flex flex-column align-items-center text-center">
                                        <img src="images/avatars/avatar-1.png" alt="Admin" className="rounded-circle p-1 bg-primary" width={150} />
                                    </div>
                                </div>
                                <div className="col-lg-10">
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <div className="inp_grp">
                                                <label>Full Name</label>
                                                <input type="text" className="form-control" defaultValue="David Smith" readOnly />
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="inp_grp">
                                                <label>Email</label>
                                                <input type="text" className="form-control" defaultValue="davidsmith@mail.com" readOnly />
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="inp_grp">
                                                <label>Country</label>
                                                <input type="text" className="form-control" defaultValue="USA" readOnly />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="inp_grp">
                                                <label>Contact Number</label>
                                                <input type="text" className="form-control" defaultValue="+0 000-0000-0000" readOnly />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="inp_grp">
                                                <label>Hiring Date</label>
                                                <input type="text" className="form-control" defaultValue="10-05-2025" readOnly />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card personal_d">
                        <div className="card-body">
                            <h2>Professional details</h2>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="inp_grp">
                                        <label>Experience Level</label>
                                        <input type="text" className="form-control" defaultValue="Intermediate" readOnly />
                                    </div>
                                    <div className="inp_grp">
                                        <label>License Number</label>
                                        <input type="text" className="form-control" defaultValue="LIC-2025-001" readOnly />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="inp_grp">
                                        <label>Game Count</label>
                                        <input type="text" className="form-control" defaultValue={120} readOnly />
                                    </div>
                                    <div className="inp_grp">
                                        <label>Certifications</label>
                                        <input type="text" className="form-control" defaultValue="FIFA Certified, UEFA Pro Level" readOnly />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card personal_d">
                        <div className="card-body">
                            <h2>Ratings &amp; Review</h2>
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="inp_grp">
                                        <label className="mb-3">GM001 - Eagles vs Hawks</label>
                                        <input type="text" className="form-control mb-1" defaultValue="by Jhon Sporting complex" readOnly />
                                        <input type="text" className="form-control mb-1" defaultValue="Execellent desicion making and control" readOnly />
                                        <input type="text" className="form-control" defaultValue="2024-08-01" readOnly />
                                        <span className="ratingg">4.5 <i className="bx bxs-star" /></span>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="inp_grp">
                                        <label className="mb-3">GM001 - Eagles vs Hawks</label>
                                        <input type="text" className="form-control mb-1" defaultValue="by Jhon Sporting complex" readOnly />
                                        <input type="text" className="form-control mb-1" defaultValue="Execellent desicion making and control" readOnly />
                                        <input type="text" className="form-control" defaultValue="2024-08-01" readOnly />
                                        <span className="ratingg">4.5 <i className="bx bxs-star" /></span>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="inp_grp">
                                        <label className="mb-3">GM001 - Eagles vs Hawks</label>
                                        <input type="text" className="form-control mb-1" defaultValue="by Jhon Sporting complex" readOnly />
                                        <input type="text" className="form-control mb-1" defaultValue="Execellent desicion making and control" readOnly />
                                        <input type="text" className="form-control" defaultValue="2024-08-01" readOnly />
                                        <span className="ratingg">4.5 <i className="bx bxs-star" /></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card personal_d">
                        <div className="card-body">
                            <h2>Documents</h2>
                            <div className="row">
                                <div className="col-lg-3">
                                    <div className="inp_grp">
                                        <Link to>
                                            <i className="bx bxs-file" />
                                            <div>
                                                <h5>Background check certificate</h5>
                                                <p>Uploaded: 2024-05-01</p>
                                                <span>View Document</span>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="inp_grp">
                                        <Link to>
                                            <i className="bx bxs-file" />
                                            <div>
                                                <h5>Licence</h5>
                                                <p>Uploaded: 2024-08-10</p>
                                                <span>View Document</span>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="inp_grp">
                                        <Link to>
                                            <i className="bx bxs-file" />
                                            <div>
                                                <h5>Registration Document</h5>
                                                <p>Uploaded: 2025-01-10</p>
                                                <span>View Document</span>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="inp_grp">
                                        <Link to>
                                            <i className="bx bxs-file" />
                                            <div>
                                                <h5>Resume</h5>
                                                <p>Uploaded: 2025-01-10</p>
                                                <span>View Document</span>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default RefereeDetail